import { InfoBox } from '@/components/sv/info-box'
import { H3 } from '@/components/sv/typographies'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Skeleton } from '@/components/ui/skeleton'

export const StaticSiteDetailsFallback = () => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>
          <H3>Details</H3>
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="flex items-start gap-8 font-normal text-sm">
          <InfoBox label="Domain" value={<Skeleton className="h-5 w-55" />} />
          <InfoBox label="Status" value={<Skeleton className="h-5 w-40" />} />
          <InfoBox label="Source" value={<Skeleton className="h-5 w-74.5" />} />
        </div>
      </CardContent>
    </Card>
  )
}
